import script from "./CreateStyle.vue?vue&type=script&lang=js"
export * from "./CreateStyle.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__